<div class="flex justify-between items-center px-4 py-2 bg-neutral-50">
  @if (hideBackButton) {
    <div class="w-[40px] h-[40px]"></div>
  } @else {
    <button class="p-3" (click)="goBack()">
      <mat-icon> arrow_back_ios </mat-icon>
    </button>
  }

  <div class="flex flex-col justify-center items-center gap-y-1 pb-1">
    <button (click)="goHome()">
      <img [src]="hotelImage" class="w-[120px] h-[100px] object-scale-down" />
    </button>
    @if (showLanguageSelector) {
      <ctr-select-chip-input [label]="'actualLanguage' | translate" [formControl]="languageControl">
        @for (language of languages; track language.code) {
          <ng-template ctrChipOption [value]="language.code">
            {{ language.name }}
          </ng-template>
        }
      </ctr-select-chip-input>
    }
  </div>

  @if (hideMenuButton) {
    <div class="w-[40px] h-[40px]"></div>
  } @else {
    <mat-icon> menu </mat-icon>
  }
</div>
